export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";